import { Logger, simulateLoadingError } from 'whisper-base';
const LOG = new Logger('[whisper-skymap-tracking]');
function WhisperSkymapTracking() {
  return {
    initialize() {
      LOG.info('Installing Whisper Skymap Tracking');

      // For testing purposes optionally simulate a loading error
      simulateLoadingError('SkymapTracking');
      LOG.info('Whisper Skymap Tracking initialized');
      return [null, () => {
        // Cleanup code here
        LOG.info('Whisper Skymap Tracking shutdown');
      }];
    }
  };
}
export default WhisperSkymapTracking;